import { render } from "./ErrorIcon.vue?vue&type=template&id=6ba3c724&scoped=true"
import script from "./ErrorIcon.vue?vue&type=script&lang=js"
export * from "./ErrorIcon.vue?vue&type=script&lang=js"

import "./ErrorIcon.vue?vue&type=style&index=0&id=6ba3c724&scoped=true&lang=css"

import exportComponent from "/Users/afolabitope/Documents/apps/redge/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ba3c724"]])

export default __exports__